import { useNavigate } from 'react-router-dom';
import P from '../texts/p/P';

export type PageBreadcrumbItem = {
  label: string;
  to?: string;
  state?: unknown;
};

interface PageBreadcrumbProps {
  items: PageBreadcrumbItem[];
}

const crumbTextStyle = { fontSize: '18px', lineHeight: '21px' };

const PageBreadcrumb = ({ items }: PageBreadcrumbProps) => {
  const navigate = useNavigate();

  if (!items.length) {
    return null;
  }

  return (
    <nav
      aria-label="breadcrumb"
      style={{
        width: '100%',
        paddingTop: '8px',
        paddingBottom: '24px',
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
        alignItems: 'center',
      }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const canNavigate = !isLast && Boolean(item.to);
        const crumb = (
          <P
            type="1"
            variant={isLast ? 'primary' : 'neutral'}
            weight={isLast ? 'bold' : 'regular'}
            withMargin={false}
            style={crumbTextStyle}
          >
            {item.label}
            {!isLast ? ' >' : ''}
          </P>
        );

        if (!canNavigate || !item.to) {
          return <span key={`${item.label}-${index}`}>{crumb}</span>;
        }

        return (
          <button
            key={`${item.label}-${index}`}
            type="button"
            aria-label={item.label}
            onClick={() => navigate(item.to as string, { state: item.state })}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            {crumb}
          </button>
        );
      })}
    </nav>
  );
};

export default PageBreadcrumb;
